import { Component, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import {
  DataLicense,
  EntityModelSubmission,
  Study,
  StudyControllerService,
  Submission,
  SubmissionControllerService
} from "../../../../modules/lipidcompass-backend-client";
import { submissionWorkflowConfig } from "../../../environments/environment";
import { LoggingService, LogLevel } from "../../_services/logging.service";
import { CommonModule, UpperCasePipe } from "@angular/common";
import { CardModule } from "primeng/card";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { ButtonGroupModule } from "primeng/buttongroup";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-define-study",
  templateUrl: "./define-study.component.html",
  styleUrls: ["./define-study.component.css"],
  standalone: true,
  imports: [
    ButtonModule,
    ButtonGroupModule,
    CardModule,
    CommonModule,
    SelectModule,
    FormsModule,
    UpperCasePipe,
    TranslateModule
  ]
})
export class DefineStudyComponent implements OnInit {
  private submissionService = inject(SubmissionControllerService);
  private studyControllerService = inject(StudyControllerService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private http = inject(HttpClient);
  private loggingService = inject(LoggingService);

  submissionId: string | undefined;
  activeIndex: number = 1;
  submission: Submission = <Submission>{};
  submitted: boolean | undefined;
  studyId: string = "LCS-00000";
  studyName: string = "Please add a name";
  nameMinLength: number = 10;
  studyDescription: string = "Please add a description";
  studyPublicationDoi: string = "Please add a publication DOI";
  descriptionMinLength: number = 20;
  dataLicenses: DataLicense[] | undefined;
  dataLicense: DataLicense | undefined;

  ngOnInit() {
    this.submissionId = this.activatedRoute.snapshot.params.id;
    if (this.submissionId) {
      this.submissionService.submissionGetById(this.submissionId).subscribe(
        result => {
          this.submission = <Submission>result;
          if (this.submission) {
            this.studyName =
              this.submission?.study?.name || "Please add a study name";
            this.studyDescription =
              this.submission?.study?.description ||
              "Please add a study description";
            this.studyId =
              this.submission?.study?.nativeId || "LCUS-" + this.submissionId;
          }
          if (!this.studyId) {
            this.studyId = "LCUS-" + this.submissionId;
          }
          this.dataLicense = this.submission?.study?.dataLicense;
        },
        error => {
          this.submission = <Submission>{};
        }
      );
      this.submissionService.submissionGetDataLicenses().subscribe(result => {
        this.dataLicenses = result?._embedded?.dataLicenses;
      });
    }
  }

  nextPage(event: any) {
    if (this.submission) {
      if (this.submission.study != null) {
        this.submission.study.name = this.studyName;
        this.submission.study.description = this.studyDescription;
        if (this.submission.study.nativeId == null) {
          this.submission.study.nativeId = this.studyId;
        }
        this.submission.study.dataLicense = this.dataLicense;
        // ensure that this.submission.study.mzTabResults[].summary.contact ids are set
        if (this.submission?.study?.mzTabResultReferences?.length > 0) {
          this.submission.study.mzTabResultReferences.forEach(ref => {
            if (ref.mzTabSummary && ref.mzTabSummary.contacts) {
              ref.mzTabSummary.contacts.forEach((contact, index) => {
                contact.id = undefined;
              });
            }
          });
        }
        if (this.submission?.study?.studySummary?.contacts?.length > 0) {
          this.submission.study.studySummary.contacts.forEach(contact => {
            contact.id = undefined;
          });
        }
        if (this.submission?.study?.studySummary?.publications?.length > 0) {
          this.submission.study.studySummary.publications.forEach(
            publication => {
              publication.id = undefined;
            }
          );
        }
        // ensure that this.submission.study.publications ids are set
        if (this.submission?.study?.mzTabResultReferences?.length > 0) {
          this.submission.study.mzTabResultReferences.forEach(ref => {
            if (ref.mzTabSummary && ref.mzTabSummary.publications) {
              ref.mzTabSummary.publications.forEach((publication, index) => {
                publication.id = undefined;
              });
            }
          });
          if (this.submission.study.mzTabResultReferences) {
            this.submission.study.mzTabResultReferences = this.submission.study.mzTabResultReferences.map(
              item => {
                return item;
              }
            );
          }
        }
        if (this.submission?.study?.studySummary?.mzTabSummaries?.length > 0) {
          this.submission.study.studySummary.mzTabSummaries.forEach(ref => {
            if (ref && ref.publications) {
              ref.publications.forEach((publication, index) => {
                publication.id = undefined;
              });
            }
            if (ref && ref.contacts) {
              ref.contacts.forEach((contact, index) => {
                contact.id = undefined;
              });
            }
          });
        }
        console.log(
          "DefineStudyComponent.nextPage: updated study: ",
          JSON.stringify(this.submission.study)
        );
        this.studyControllerService
          .studySaveSingle(this.submission.study)
          .subscribe(response => {
            this.loggingService.log(
              "DefineStudyComponent",
              "NextPage saved study: " + JSON.stringify(response),
              LogLevel.DEBUG
            );
            this.router.navigate(
              [
                submissionWorkflowConfig.workflows.mzTab.steps[this.activeIndex]
                  .routerLink,
                this.submissionId
              ],
              { relativeTo: this.activatedRoute.parent }
            );
          });
      }
    } else {
      this.router.navigate(
        [
          submissionWorkflowConfig.workflows.mzTab.steps[this.activeIndex]
            .routerLink,
          this.submissionId
        ],
        { relativeTo: this.activatedRoute.parent }
      );
    }
    return;
  }

  previousPage(event: any) {
    if (this.submission) {
      this.submissionService
        .submissionSaveSingle(this.submission)
        .subscribe(response => {
          this.loggingService.log(
            "DefineStudyComponent",
            "PreviousPage saved submission: " + JSON.stringify(response),
            LogLevel.DEBUG
          );
          this.router.navigate(submissionWorkflowConfig.parentRoute);
        });
    } else {
      this.router.navigate(submissionWorkflowConfig.parentRoute);
    }
    return;
  }

  cancel(event: any) {
    this.router.navigate(submissionWorkflowConfig.parentRoute);
    return;
  }

  resolveDoiMetadata(event: any) {
    if (this.studyPublicationDoi && this.studyPublicationDoi.length > 0) {
      this.loggingService.log(
        "DefineStudyComponent",
        "Resolve DOI metadata: " + this.studyPublicationDoi,
        LogLevel.DEBUG
      );
      var extractedDoi = this.studyPublicationDoi.replace(
        /(http:\/\/|https:\/\/|dx.doi.org|doi.org|doi:)/g,
        ""
      );
      this.loggingService.log(
        "DefineStudyComponent",
        "Extracted DOI: " + extractedDoi,
        LogLevel.DEBUG
      );
      const doiRegex = new RegExp("10.\\d{4,9}/[-._;()/:A-Z0-9]+", "i");
      if (doiRegex.test(extractedDoi)) {
        var urlTemplate = "https://api.crossref.org/works/";
        var url = urlTemplate + extractedDoi + "?mailto=contact@lifs-tools.org";
        this.loggingService.log(
          "DefineStudyComponent",
          "Resolve DOI metadata: " + url,
          LogLevel.DEBUG
        );
        this.http
          .get(url, {
            headers: {
              "Access-Control-Allow-Origin": "https://api.crossref.org",
              "User-Agent": "lipidcompass"
            }
          })
          .subscribe(response => {
            this.loggingService.log(
              "DefineStudyComponent",
              "CrossRef response: " + JSON.stringify(response),
              LogLevel.DEBUG
            );
            if (response && response["status"] && response["status"] == "ok") {
              if (response["message"]) {
                if (
                  response["message"]["license"] &&
                  response["message"]["license"].length > 0
                ) {
                  this.loggingService.log(
                    "DefineStudyComponent",
                    "License: " + response["message"]["license"],
                    LogLevel.DEBUG
                  );
                }
                if (
                  response["message"]["title"] &&
                  response["message"]["title"].length > 0
                ) {
                  this.studyName = response["message"]["title"][0];
                }
                if (
                  response["message"]["abstract"] &&
                  response["message"]["abstract"].length > 0
                ) {
                  this.studyDescription = response["message"]["abstract"][0];
                }
                if (
                  response["message"]["URL"] &&
                  response["message"]["URL"].length > 0
                ) {
                  this.loggingService.log(
                    "DefineStudyComponent",
                    "URL: " + response["message"]["URL"],
                    LogLevel.DEBUG
                  );
                }
                if (
                  response["message"]["published"] &&
                  response["message"]["published"]["date-parts"] &&
                  response["message"]["published"]["date-parts"].length > 0
                ) {
                  this.loggingService.log(
                    "DefineStudyComponent",
                    "Published: " +
                      response["message"]["published-print"]["date-parts"][0],
                    LogLevel.DEBUG
                  );
                }
                if (
                  response["message"]["author"] &&
                  response["message"]["author"].length > 0
                ) {
                  this.loggingService.log(
                    "DefineStudyComponent",
                    "Authors: " + response["message"]["author"],
                    LogLevel.DEBUG
                  );
                }
                if (
                  response["message"]["container-title"] &&
                  response["message"]["container-title"].length > 0
                ) {
                  this.loggingService.log(
                    "DefineStudyComponent",
                    "Journal: " + response["message"]["container-title"][0],
                    LogLevel.DEBUG
                  );
                }
              }
            } else {
              this.loggingService.log(
                "DefineStudyComponent",
                "CrossRef response status not ok: " + JSON.stringify(response),
                LogLevel.DEBUG
              );
            }
          });
        return;
      }
    }
    this.loggingService.log(
      "DefineStudyComponent",
      "Invalid DOI: " + this.studyPublicationDoi,
      LogLevel.DEBUG
    );
  }
}
